module.exports = __webpack_public_path__ + "static/logo-bw-ffaa7b75ba3991c3775689ad2ae2123e.png";